export const isEmpty = (obj: object | void | null) => Object.keys(obj || {}).length === 0;
